// extracted by mini-css-extract-plugin
module.exports = {"pagination":"oMsH8","col2":"uN43u","updateText":"DVenm"};